import { Component, ElementRef, Inject, ViewChild, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FnUtilService, FnToasterService, FnCheckboxFilterItem, FnTagData } from 'foundation';
import { PosHttpService } from '../../../services/pos.http.service';
import { EOCommentDetail } from '../../../modal/entity.modal';
import { MailTeam } from '../../../modal/entity.modal';

@Component({
  selector: 'app-dashboard-mail-model',
  templateUrl: './dashboard-mail-model.component.html',
  styleUrl: './dashboard-mail-model.component.scss',
  encapsulation: ViewEncapsulation.None
})

export class DashboardMailModelComponent {
  toEmail: Array<FnCheckboxFilterItem> = [];
  ccEmail: string = '';
  commentObject: { textComment: string } = { textComment: '' };
  isSendTelegram: boolean = false;
  isSelected: boolean = false;
  commentArr: EOCommentDetail[] = [];
  selectedMail: Array<any> = [];
  isGrouping = false;
  mailTeamArray: MailTeam[] = [];
  ccMailTeamArray: MailTeam[] = [];
  emailInput: any= '';
  filteredEmailSuggestions: string[] = [];

  constructor(@Inject(MAT_DIALOG_DATA) public dialogData: HwDialogData, private dialogRef: MatDialogRef<DashboardMailModelComponent>, private posHttpSvcs: PosHttpService, private fnutilservice: FnUtilService, private toaster: FnToasterService) { }

  close() {
    this.dialogRef.close();
  }

  ngOnInit() {
    this.loadMailArray();
    this.loadMailData();
  }

  loadMailArray() {
    this.posHttpSvcs.authPost('v1/ui/loadMailArray', 'loadMailArray', this.dialogData.mail.primaryKey).subscribe((resp => {
      if (resp.isError) {
        this.toaster.error("Mail Array is not loaded");
      } else {
        this.ccMailTeamArray = resp.data ? resp.data.split(',') : [];
        this.ccEmail = resp.data;
      }
    }));
  }

  loadMailData() {
    this.posHttpSvcs.authGet('v1/ui/loadEoMailTeam', 'loadEoMailTeam').subscribe((resp => {
      if (resp.isError) {
        this.toaster.error("Error in Loading MailData");
      }
      this.mailTeamArray = resp.data;
      const array = resp.data;
      array.forEach((data: MailTeam) => {
        this.toEmail.push({ id: `${data.id}`, description: data.id, isSelected: undefined });
      })
    }))
  }

  selectMail(event: any) {
    const selectedEmails: string[] = [];
    for (const item of event) {
      if (item && item.name) {
        selectedEmails.push(item.name);
      }
    }
    this.selectedMail = selectedEmails;
    console.log("Selected Emails:", this.selectedMail);
  }

  escalate() {
    if (this.fnutilservice.isEmptyObject(this.commentObject.textComment)) {
      this.toaster.error('Please add comment here...');
      return
    }
    if (this.selectedMail.length === 0 || this.selectedMail.includes("0")) {
      this.toaster.error("Please select a valid recipient email.");
      return;
    }
    if (!this.validateEmail(this.selectedMail)) {
      this.toaster.error('Invalid format in default EmailID');
      throw new Error('Invalid defaultEscEmailID');
    }
    var hash = {
      "toEmailID": this.selectedMail,
      "ccEmailID": this.ccEmail.toString(),
      "comment": this.commentObject.textComment,
      "fileInfo": this.fileHashArray,
      "pk": this.dialogData.mail.primaryKey
    }
    this.posHttpSvcs.authPost('v1/ui/escalate', 'escalate', hash).subscribe((resp => {
      if (resp.isError) {
        this.toaster.error(resp.data);
        return;
      } else {
        if (this.isSendTelegram) {
          this.loadComments();
        }
        this.toaster.success(resp.data);
      }
    }));
    this.close();
  }
  
  filterEmails() {
  const query = this.emailInput.trim().toLowerCase();
  if (!query) {
    this.filteredEmailSuggestions = [];
    return;
  }
  this.filteredEmailSuggestions = this.mailTeamArray
    .map(mt => mt.name)
    .filter(name =>
      name.toLowerCase().includes(query) &&
      !this.selectedMail.includes(name)
    );
}

  addEmailFromInput() {
    if (this.filteredEmailSuggestions.length > 0) {
      const suggestion = this.filteredEmailSuggestions[0];
      this.addEmail(suggestion);
    } else {
      const email = this.emailInput.trim();
      if (email && !this.selectedMail.includes(email)) {
        this.selectedMail.push(email);
      }
      this.emailInput = '';
      this.filteredEmailSuggestions = [];
    }
  }

  addEmail(email: string) {
    if (!this.selectedMail.includes(email)) {
      this.selectedMail.push(email);
    }
    this.emailInput = '';
    this.filteredEmailSuggestions = [];
  }

  removeEmail(index: number) {
    this.selectedMail.splice(index, 1);
  }

  emailRegex = new RegExp("^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$");

  validateEmail(emailString: any): boolean {
    if (!emailString) {
      return false;
    }
    const emailArray = emailString;
    for (let i = 0; i < emailArray.length; i++) {
      const email = emailArray[i].trim();
      if (!this.emailRegex.test(email)) {
        return false;
      }
    }
    return true;
  }

  loadComments(): void {
    this.posHttpSvcs.authPost('v1/ui/getEOCommentArray', 'getEOCommentArray', this.dialogData.mail.primaryKey).subscribe((resp: { isError: string; data: EOCommentDetail[]; }) => {
      if (resp.isError) {
        this.toaster.error("EOCommentArray is not loaded");
      }
      this.commentArr = resp.data;
      this.sendtoTelegram();
    }
    );
  }

  sendtoTelegram(): void {
    let msg = `Action: Escalated\n`;

    const filteredComments = this.commentArr.map(comment => {
      return comment;
    });
    if (filteredComments.length === 1) {
      const latestComment = filteredComments[filteredComments.length - 1];
      msg += `Action By : ${latestComment.commentedBy}\n`;
      msg += `Action At : ${latestComment.commentedAt}\n`;
      msg += `Comment : ${latestComment.commentText}\n`;
    } else if (filteredComments.length >= 2) {
      const lastComment = filteredComments[filteredComments.length - 1];
      const latestComment = filteredComments[filteredComments.length - 2];
      msg += `Action By : ${lastComment.commentedBy}\n`;
      msg += `Action At : ${lastComment.commentedAt}\n`;
      msg += `Comment: ${lastComment.commentText}\n\n`;
      msg += `Last Action By : ${latestComment.commentedBy}\n`;
      msg += `Last Action At : ${latestComment.commentedAt}\n`;
      msg += `Last Comment : ${latestComment.commentText}\n`;
    }
    const pktData = {
      msg: msg,
      pk: this.dialogData.mail.primaryKey
    };
    this.posHttpSvcs.authPost('v1/ui/generateTelegram', 'generateTelegram', pktData).subscribe((resp => {
      if (resp.isError) {
        this.toaster.error("Telegram Msg not saved");
        return;
      }
    }));
  }

  @ViewChild('fileUploadInput') fileUploadInput!: ElementRef;

  fileName: string = 'Add Attachment';
  fileHashArray: any[] = [];
  fileHash: any = {};

  triggerFileUpload(): void {
    this.fileUploadInput.nativeElement.click();
  }

  handleSelectedFile(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (!input.files || input.files.length === 0) {
      return;
    }

    const files = Array.from(input.files);
    this.fileHashArray = [];

    files.forEach((file) => {
      const size = parseFloat((file.size / 1024 / 1024).toFixed(2));
      if (size > 20) {
        this.toaster.error('Files size should be less than 20MB', 'error');
        return;
      }
      this.readFile(file);
    });
  }

  readFile(file: File): void {
    const reader = new FileReader();
    reader.readAsBinaryString(file);
    reader.onload = (event: ProgressEvent<FileReader>) => {
      if (event.target && event.target.result) {
        const icalStr = event.target.result as string;
        const fileHash = {
          mimeType: file.type,
          detail: btoa(icalStr),
          fileName: file.name
        };
        this.fileHashArray.push(fileHash);
        this.fileName =
          this.fileName === 'Add Attachment'
            ? file.name
            : `${this.fileName}, ${file.name}`;
      }
    };

    reader.onerror = () => {
      this.toaster.error('Error loading file', 'error');
    };
  }

  selectionCheck(event: any): void {
    this.isSelected = event.target.checked;
  }
}

interface HwDialogData {
  mail: any;
}